import { Box } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { createAppTheme } from '@myhrbox/myhrbox-frontend-core';
import SYSTEM_FONT_FAMILY from 'constants/fontFamily';
import { ReactNode } from 'react';

interface PublicThemeProviderProps {
  children: ReactNode;
}

const typographyVariants = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'subtitle1',
  'subtitle2',
  'body1',
  'body2',
  'button',
  'caption',
  'overline',
  'h40',
  'h34',
  'h28',
  'h24m',
  'h24rg',
  'h24',
  'h20',
  'text',
  'subtitle18rg',
  'subtitle18lg',
  'body16',
  'body16rg',
  'body14rg',
  'describe',
  'describe2',
] as const;

const baseTheme = createAppTheme();
const publicTheme = createTheme(baseTheme, {
  typography: {
    fontFamily: SYSTEM_FONT_FAMILY,
    ...Object.fromEntries(
      typographyVariants.map((variant) => [
        variant,
        {
          ...baseTheme.typography[variant],
          fontFamily: SYSTEM_FONT_FAMILY,
        },
      ]),
    ),
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: SYSTEM_FONT_FAMILY,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: SYSTEM_FONT_FAMILY,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: SYSTEM_FONT_FAMILY,
        },
        input: {
          fontFamily: SYSTEM_FONT_FAMILY,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: SYSTEM_FONT_FAMILY,
        },
      },
    },
  },
});

const PublicThemeProvider = ({ children }: PublicThemeProviderProps) => {
  return (
    <ThemeProvider theme={publicTheme}>
      <Box sx={{ minHeight: '100%', fontFamily: SYSTEM_FONT_FAMILY }}>{children}</Box>
    </ThemeProvider>
  );
};

export default PublicThemeProvider;
